<template>
    <div class="flex flex-col space-y-5">
        <div class="text-center">
            Choose Sheathing
        </div>

        <div class="">
            <div class="flex flex-wrap -mx-2">
                <IconButton v-if="baseWall ==='steel-frame'" :on-click="() => $emit('update:modelValue', 'gypsum')"
                            :is-active="modelValue === 'gypsum'">
                    GYPSUM
                    <template v-slot:icon>
                        <img src="../../../img/wall-builder/layers/02-gypsum.png" class="-mb-[25px]"/>
                    </template>
                </IconButton>
                <IconButton v-if="baseWall ==='steel-frame'" :on-click="() => $emit('update:modelValue', 'none')"
                            :is-active="modelValue === 'none'">
                    NONE
                    <template v-slot:icon>
                        <img src="../../../img/wall-builder/layers/01-steel.png" class="-mb-[25px]"/></template>
                </IconButton>
                <IconButton v-if="baseWall ==='wood-frame'" :on-click="() => $emit('update:modelValue', 'osb')"
                            :is-active="modelValue === 'osb'">
                    OSB
                    <template v-slot:icon>
                        <img src="../../../img/wall-builder/layers/02-gypsum.png" class="-mb-[25px]"/>
                    </template>
                </IconButton>
                <IconButton v-if="baseWall ==='wood-frame'" :on-click="() => $emit('update:modelValue', 'plywood')"
                            :is-active="modelValue === 'plywood'">
                    PLYWOOD
                    <template v-slot:icon>
                        <img src="../../../img/wall-builder/layers/02-plywood.png" class="-mb-[25px]"/></template>
                </IconButton>
                <IconButton :on-click="() => $emit('update:modelValue', 'other')" :is-active="modelValue === 'other'">
                    OTHER
                    <template v-slot:icon>
                        <img src="../../../img/wall-builder/layers/02-other.png" class="-mb-[25px]"/>
                    </template>
                </IconButton>
            </div>
        </div>
    </div>
</template>

<script>
import IconButton from "../components/IconButton.vue";

export default {
    data() {
        return {}
    },
    emits: ['update:modelValue'],
    props: {
        baseWall: String,
        modelValue: {
            type: String,
            default: null
        }
    },
    components: {
        IconButton
    }
}
</script>
